import React from "react";

export default function BinLid() {
  return (
    <svg width="14" height="3" viewBox="0 0 14 3" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.5 1L9.5 0H4.5L3.5 1H0V3H14V1H10.5Z" fill="black" />
    </svg>
  );
}
